<h2 class="text-center" mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer">
    <form [formGroup]="transfertForm" (ngSubmit)="onSubmit()">
      <div class="formGroup">
        <p>
          <span class="font-weight-bold mr-3">Nom du bien</span
          ><span>{{ data.prop.name }}</span>
        </p>
        <p>
          <span class="font-weight-bold mr-3">Propriétaire</span
          ><span>{{
            UserHelper.userSummmaryDisplayName(data.prop.owner)
          }}</span>
        </p>
      </div>
      <div class="formGroup">
        <mat-form-field class="w-100">
          <mat-label>Email du nouveau propriétaire</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            required
            formControlName="newOwnerEmail"
          />
          <mat-hint align="end"
            >Seuls les "Particuliers" sont éligibles</mat-hint
          >
          <mat-error>
            <span *ngIf="f('newOwnerEmail').hasError('required')"
              >Veuillez saisir une adresse email</span
            >
          </mat-error>
          <mat-error>
            <span *ngIf="f('newOwnerEmail').hasError('email')"
              >Veuillez saisir une adresse email valide</span
            >
          </mat-error>
        </mat-form-field>
      </div>

      <div class="formValidation" class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          type="submit"
          [disabled]="formSubmitting"
        >
          Transférer
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
